import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { throttle } from 'lodash-es'
import { filterTree } from '@ow/utils'
import { Tree } from '../tree'
import Input from '../input/input-base'

const SearchTree = function (props) {
  const {
    data,
    height,
    searchBarClassName,
    placeholder = '请输入',
    ...others
  } = props
  const [inputValue, setInputValue] = useState()
  const [keyWord, setKeyWord] = useState('')

  const searchTree = throttle(
    (value) => {
      if (value === '' || !value) {
        setKeyWord('')
      } else {
        setKeyWord(value)
      }
    },
    1000,
    { trailing: true }
  )

  useEffect(() => {
    searchTree(inputValue)
  }, [inputValue])

  const filteredTreeData = () => {
    return keyWord.length > 0 ? filterTree(data, keyWord) : data
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="px-3">
        <Input
          className={clsx('w-full', searchBarClassName)}
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value)
          }}
        />
      </div>
      <div style={{ height: height || 'calc(100vh - 210px)' }}>
        <Tree data={filteredTreeData()} {...others} />
      </div>
    </div>
  )
}

export default SearchTree
